module.exports = __webpack_public_path__ + "img/update.0c9fd60a.svg";